import { MyUtil } from "../util/MyUtil"

const state = {
  cartDot: false,
  cartNum: 0,
  cartFlag: 0, // 用于刷新购物车图标上的数字和价格
  cart: MyUtil.getLocalCart(),
  msgNum: 0
}

export default state



// WEBPACK FOOTER //
// ./src/store/state.js